// extracted by mini-css-extract-plugin
module.exports = {"CocktailWrapper":"CocktailWrapper_CocktailWrapper__2psK-","BigImage":"CocktailWrapper_BigImage__28c5J"};